import { Injectable } from '@angular/core';
import { navigation } from '../constants/navigation';
import { CognitoService } from './cognito.service';
import { Roles } from '../constants/roles';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  list: any[] = [];
  listFull: any[] = navigation;

  constructor(private cognito: CognitoService) {}

  // Filter navigation once using a single role/type lookup
  public async filterList(): Promise<any> {
    const filteredList: any[] = [];
    const { roleLabels, userType } = await this.getUserAccessProfile();

    for (const item of this.listFull) {
      if (!item.validation) {
        filteredList.push(item);
        continue;
      }

      const roleAllowed = item.userRole.some((role: string) =>
        roleLabels.includes(role)
      );
      const typeAllowed = item.userType
        ? item.userType === userType
        : true;

      if (roleAllowed && typeAllowed) {
        filteredList.push(item);
      }
    }

    this.list = filteredList.sort(this.sortByNumberAscending);
  }

  private async getUserAccessProfile(): Promise<{ roleLabels: string[]; userType: string }> {
    const user = await this.cognito.getUser();
    const rolesResponse: any = await this.cognito.getRolesForUser(
      user.attributes.sub
    );

    const roleLabels =
      Array.isArray(rolesResponse)
        ? rolesResponse
            .map((r: any) => {
              const match = Roles.find((entry) => entry.value === r.role?.toString());
              return match?.label;
            })
            .filter((r: string | undefined): r is string => !!r)
        : [];

    const userType = user.attributes['custom:user_type'] || '';
    return { roleLabels, userType };
  }

  //order array of list items based on the "number" attribute
  sortByNumberAscending(a: any, b: any): number {
    const numberA = parseInt(a.number);
    const numberB = parseInt(b.number);

    return numberA - numberB;
  }
}
